import DomainConfigurationSimpleForm from './DomainConfigurationSimpleForm'

export default DomainConfigurationSimpleForm
